import axios, { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';

import { AuthActionTypes } from './AuthConstants';
import * as AuthTypes from './AuthTypes';
import { API_HOST } from '../globals';
import { TOKEN_NAME_KEY, USER_NAME_KEY, handleLogin, clearStore, isBrowser } from '../globals/auth';

export const signedIn = (data: any): AuthTypes.SignedInAction => ({
  type: AuthActionTypes.SIGNED_IN,
  payload: data,
});

export const signInFailed = (response): AuthTypes.SignInFailedAction => ({
  type: AuthActionTypes.SIGN_IN_ERROR,
  response,
});

export const signedOut = (): AuthTypes.SignedOutAction => ({
  type: AuthActionTypes.SIGNED_OUT,
});

export const reConnecting = (): AuthTypes.ReConnectingAction => ({
  type: AuthActionTypes.RECONNECTING,
});

export const signIn = (data = {}, ApiHost = API_HOST) => {
  return async (dispatch: Function): Promise<any> => {
    const postData = { ...data, ...{ grant_type: 'password' } };

    const encodeForm = data => {
      return Object.keys(data)
        .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
        .join('&');
    };

    const endpoint = ApiHost + '/oauth/token';

    const config: object = {
      method: 'post',
      url: endpoint,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'cache-control': 'no-cache',
      },
      data: encodeForm(postData),
    };

    try {
      await axios(config)
        .then((response: AxiosResponse) => {
          if (response.data.access_token) {
            //
            localStorage.setItem(TOKEN_NAME_KEY, response.data.access_token);
            localStorage.setItem(USER_NAME_KEY, data['username']);

            //set cookies for domain level login
            handleLogin(response.data.access_token);

            dispatch(signedIn(response.data));
            toast.success('Connected');
          } else {
            dispatch(signInFailed('Login error, please try again later'));
          }
        })
        .catch((error: any) => {
          console.log('Axios Fail: ', error.response);
          dispatch(signInFailed(error.response.data.error_description));
        });
    } catch (error) {
      console.log('Error: ' + error);
      dispatch(signInFailed(error));
    }
  };
};

export const signOut = () => {
  return async dispatch => {
    localStorage.removeItem(TOKEN_NAME_KEY);

    if (isBrowser) clearStore();

    dispatch(signedOut());
  };
};

export const reConnect = () => {
  return async dispatch => {
    localStorage.removeItem(TOKEN_NAME_KEY);

    if (isBrowser) clearStore();

    dispatch(reConnecting());
  };
};
